import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// Importing and configuring firebase
import firebase from 'firebase/app';
import 'firebase/auth'; 
import 'firebase/database';

var config = {
    apiKey: "AIzaSyDBiFwTsRVdOL79SJ9IBC5-ZfxFSga2B9o",
    authDomain: "grubrun-82d3a.firebaseapp.com",
    databaseURL: "https://grubrun-82d3a.firebaseio.com",
    projectId: "grubrun-82d3a",
    storageBucket: "grubrun-82d3a.appspot.com",
    messagingSenderId: "724484470199"
};

firebase.initializeApp(config);

ReactDOM.render(<BrowserRouter basename={process.env.PUBLIC_URL+'/'}><App /></BrowserRouter>, document.getElementById('root'));
